import React from "react";
import {
  PieChart,
  TrendingUp,
  Shield,
  Building2,
  Users,
  Calculator,
} from "lucide-react";

const ServicesSection = () => {
  return (
    <section
      id="servicios"
      className="py-24 bg-gradient-to-br from-[#14840c] to-green-700"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-6">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-green-100 max-w-3xl mx-auto font-medium">
            Soluciones financieras personalizadas para proteger, crecer y
            optimizar tu patrimonio
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Servicios para Personas */}
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 p-8 rounded-2xl">
            <h3 className="text-3xl font-bold text-white mb-4">
              SERVICIOS PARA PERSONAS
            </h3>
            <p className="text-green-100 mb-8 font-medium">
              Soluciones financieras personalizadas para proteger, crecer y
              optimizar tu patrimonio.
            </p>

            <div className="space-y-6">
              {[
                {
                  icon: PieChart,
                  title: "Inversiones Personalizadas",
                  desc: "Crea un futuro financiero con estrategias que se adaptan a tus objetivos.",
                },
                {
                  icon: TrendingUp,
                  title: "Crédito Inteligente",
                  desc: "Convierte el crédito en una herramienta de crecimiento responsable.",
                },
                {
                  icon: Shield,
                  title: "Evaluación de Seguros Personales",
                  desc: "Protección integral para ti y tu familia con coberturas inteligentes.",
                },
              ].map((service, index) => (
                <div
                  key={index}
                  className="border border-white/20 p-6 rounded-xl bg-white/5"
                >
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <service.icon className="w-6 h-6 text-green-200" />
                    </div>
                    <div>
                      <h4 className="font-bold text-white mb-2">
                        {service.title}
                      </h4>
                      <p className="text-green-100 text-sm font-medium">
                        {service.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="w-full mt-8 bg-green-600 hover:bg-green-500 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-300">
              EXPLORAR SERVICIOS
            </button>
          </div>

          {/* Servicios para Empresas */}
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 p-8 rounded-2xl">
            <h3 className="text-3xl font-bold text-white mb-4">
              SERVICIOS PARA EMPRESAS
            </h3>
            <p className="text-green-100 mb-8 font-medium">
              Asesoría financiera especializada para organizaciones en
              expansión.
            </p>

            <div className="space-y-6">
              {[
                {
                  icon: Building2,
                  title: "Fuentes de Financiamiento Empresarial",
                  desc: "Diseña una estrategia de crecimiento con capital estructurado.",
                },
                {
                  icon: Users,
                  title: "Seguros Corporativos",
                  desc: "Protege tus activos y equipo humano con soluciones a la vanguardia.",
                },
                {
                  icon: Calculator,
                  title: "Consultoría Financiera Estratégica",
                  desc: "Profesionaliza la gestión financiera de tu empresa.",
                },
              ].map((service, index) => (
                <div
                  key={index}
                  className="border border-white/20 p-6 rounded-xl bg-white/5"
                >
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <service.icon className="w-6 h-6 text-green-200" />
                    </div>
                    <div>
                      <h4 className="font-bold text-white mb-2">
                        {service.title}
                      </h4>
                      <p className="text-green-100 text-sm font-medium">
                        {service.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="w-full mt-8 bg-green-600 hover:bg-green-500 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-300">
              EXPLORAR SERVICIOS
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
